<div
  class="sz-card"
  [class.sz-card--flat]="variant() === 'flat'"
  [class.sz-card--featured]="variant() === 'featured'"
  [class.sz-card--subtle]="variant() === 'subtle'">
  <ng-content />
</div>
